<template>
  <div class="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-100">
    <header class="bg-white/80 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div class="flex items-center justify-between">
          <router-link to="/" class="flex items-center group">
            <h1 class="text-2xl font-bold bg-gradient-to-r from-primary-600 to-indigo-600 bg-clip-text text-transparent group-hover:from-primary-700 group-hover:to-indigo-700 transition-all">
              Online Tools
            </h1>
          </router-link>
          <p class="text-gray-500 text-sm hidden sm:block">Professional Tools</p>
        </div>
      </div>
    </header>

    <main class="flex-1 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <router-view />
    </main>

    <footer class="py-6 border-t border-gray-200 bg-white/50">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-gray-500 text-sm">
        <p>Built with Vue 3</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
</script>
